import React, {useEffect} from 'react';
import {useStore} from "@/app/providers/StoreProvider";
import {Loading} from "@/shared/ui/Loading";
import {observer} from "mobx-react-lite";

import arrowRight from '@/shared/pictures/arrow_right.svg';
import questCheck from '@/shared/pictures/quest_check.png';

import puck from '@/shared/pictures/hud_puck.png';
import energy from '@/shared/pictures/hud_energy.png';
import {IQuestGiftType, IQuestItem, IQuestItemType} from "@/entities/quest/types";

export const QuestsPage = observer(() => {

    const {questsStore, modalStore} = useStore();
    const {quests,loading} = questsStore;

    useEffect(()=>{
        const fetchQuests = async () => {
            await questsStore.getQuests();
        }

        if(Object.entries(quests).length === 0){
            fetchQuests()
        }
    },[])


    const openModal = (id: string, item:IQuestItem) =>{
        if(item.questType == IQuestItemType.Check){
            modalStore.open("questCheck",{id,item});
        }else if(item.questType == IQuestItemType.Daily){
            modalStore.open("questDaily",{id,item});
        }else if(item.questType == IQuestItemType.Input){
            modalStore.open("questInput",{id,item});
        }
    }

    const getGiftImage = (type:IQuestGiftType) => {
        if(type == IQuestGiftType.Energy){
            return <img className="quests-item_giftImage" src={energy} alt=""/>
        }else if(type == IQuestGiftType.Score){
            return <img className="quests-item_giftImage" src={puck} alt=""/>
        }else {
            return null
        }
    }

    if(loading) return <Loading/>

    return (
        <div className='quests-page'>
            <div className="container">
                <h1 className='quests-page_title'>Задания</h1>

                <div className='quests-items'>
                    {Object.entries(quests).map(([id, questItem]) => (
                        <div className={`quests-item ${questItem.completed&&'quests-item_completed'}`} key={id} onClick={()=> !questItem.completed&&openModal(id,questItem)}>

                            <img className='quests-item_image' src={questItem.imageUrl} alt=""/>

                            <div className='quests-item_content'>
                                <h2 className='quests-item_condition'>
                                    {questItem.conditionText}
                                </h2>
                                <p className='quests-item_giftText'>
                                    {getGiftImage(questItem.giftType)}

                                    {questItem.giftText}
                                </p>
                            </div>

                            {questItem.completed
                                ?<img className="quests-item_check" src={questCheck} alt=""/>
                                :<img className="quests-item_arrow" src={arrowRight} alt=""/>
                            }



                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
});
